import { Resolver } from 'react-hook-form';
import required from 'src/utils/validation/required';
import email from 'src/utils/validation/email';
import {
  validateFieldSync,
  validateFormSync,
} from 'src/utils/validation/validate-generators';
import { emailField } from 'src/services/registration/registration.config';

export const formRecoveryPasswordConfig = () => {
  const initialValues = {
    [emailField]: '',
  };

  const validate = validateFormSync({
    [emailField]: validateFieldSync(required, email),
  });

  const resolver: Resolver<any> = async (values: any) => {
    return {
      values: values,
      errors: validate(values),
    };
  };
  return { initialValues, resolver };
};
